import WxmElTree from './src/main.vue';

WxmElTree.install = function(Vue){
    Vue.component(WxmElTree.name , WxmElTree)
};
if (typeof window !== 'undefined' && window.Vue) {
    WxmElTree.install(window.Vue);
}

export default WxmElTree;